const V1_BASE_MESSAGES_URL = 'v1/messages';

export const MESSAGES_PAGE_URL = `${V1_BASE_MESSAGES_URL}?per_page=20`;
export const MESSAGE_DETAIL_URL = `${V1_BASE_MESSAGES_URL}/:id`;
export const READ_MESSAGE_URL = `${MESSAGE_DETAIL_URL}/read`;
export const UNREAD_MESSAGE_URL = `${MESSAGE_DETAIL_URL}/unread`;
export const SPAM_MESSAGE_URL = `${MESSAGE_DETAIL_URL}/spam`;
export const BULK_MESSAGES_URL = `${V1_BASE_MESSAGES_URL}/bulk`;
export const UNREAD_MESSAGES_COUNT_URL = `${V1_BASE_MESSAGES_URL}/unread/count`;
